import React, { useEffect, useRef, useState } from "react";
import LedgerService, {
  SearchLedgerByGroupsTypes,
} from "../../Services/LedgerService";
import { useNavigate, useParams } from "react-router-dom";
import { useClient } from "../../Context/ClientContext";
// import { notificationContext } from "../../Common/PageRoute";
import {
  Avatar,
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Spin,
  Tooltip,
  Upload,
} from "antd";
import { useLocation } from "react-router-dom";
import { dayjs } from "../../../Utilities/dayjs";
import {
  CloseOutlined,
  LoadingOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import {
  handleDecimalValues,
  handleInputFocus,
  Utils,
} from "../../../Utilities/Utils";
import VoucherServices, {
  Party_Tax,
  Voucher_Type,
  VoucherMode,
} from "../../Services/VoucherServices";
import noteContext from "../../Context/StyleContext";
import deleteImg from "../../../images/deletebutton.svg";
import { ConfirmationModal } from "../../Common/ConfirmationModal";
import { notificationContext } from "../../Common/Routing/PageRoute";
import { AddLedger } from "../Master/Ledger/AddLedger";
import TextArea from "antd/es/input/TextArea";
import EntryLevelKeys from "../../Common/EntryLevelKeys";
import DraftService from "../../Services/DraftService";
import DocumentPreview from "../../Common/DocumentPreview";
import { useTheme } from "../../Context/ThemeContext";
import {
  SettingsSections,
  vouchersSettings,
} from "../../Services/SettingService";
import { findUserOnlyOnePremission } from "../Users/Roles/UserSecurityFind";
import { useUser } from "../../../Context/UserContext";
import { IsetAssetRef } from "./IJournal";
import { P } from "@antv/g2plot";
import { useHotkey } from "../../Context/HotKeyContext";
interface IBankIdAndBalnce {
  id: string;
  balance: number;
}

const AddJournal = () => {
  const { showKeys } = useHotkey();
  const navigate = useNavigate();
  const location = useLocation();
  const themeData: any = useTheme();
  const { journalId, draftId } = useParams();
  const { currentClient, companySettings } = useClient();
  const { clientSpecificRole } = useUser();
  const { windowWidth } = React.useContext(noteContext);
  const { openNotification } = React.useContext(notificationContext);

  // const [itemList, setItemList] = useState<any[]>([]);sadasdadsds
  const [form] = Form.useForm();
  //   const [accountLedgerOption, setAccountLedgerOption] = React.useState<any[]>(
  //     []
  //   );
  const [partyLedgerOption, setPartyLedgerOption] = React.useState<any[]>([]);
  const [selectedPartyOption, setSelectedPartyOption] = React.useState<any[]>(
    []
  );
  const [selectedBankBalance, setSelectedBankBalance] = React.useState<any[]>(
    []
  );
  const [editInvBankDetails, setEditInvBankDetails] = React.useState<any[]>([]);

  const [trigger, setTrigger] = React?.useState(false);
  const [openModel, setOpenModel] = React?.useState<{
    type: string;
    param: any;
  }>({
    type: "",
    param: {},
  });
  const [loading, setLoading] = React.useState<boolean>(false);
  const [isVoucherLocked, setIsVoucherLocked] = React.useState<boolean>(false);
  const [isOpeningOrClosingVoucher, setIsOpeningOrClosingVoucher] =
    React.useState<boolean>(false);
  const [itemLength, setItemLength] = React.useState<number>(0);
  const [deleteItemList, setDeleteItemList] = React.useState<{
    name: any;
    index: number;
  }>({
    name: "",
    index: -1,
  });
  const [confirmation, setConfirmation] = React.useState<boolean>(false);
  //   const [currentBalance, setCurrentBalance] = React.useState<number>(0);
  const [accountIsParty, setAccountIsParty] = React.useState<Party_Tax>();
  const [partyRef, setPartyRef] = React.useState<any[]>([]);
  const [assetRef, setAssetRef] = React.useState<IsetAssetRef[][]>([]);
  const [selectPartyRef, setSelectPartyRef] = React.useState<any[]>([[]]);
  const [selectAssetRef, setSelectAssetRef] = React.useState<string[][]>([[]]);
  const [saveButtonLoading, setSaveButtonLoading] =
    React.useState<boolean>(false);
  const [totalPaymentIn, setTotalPaymentIn] = React.useState<number>(0);
  const [disabledAmountInputs, setDisabledAmountInputs] = React.useState<
    Party_Tax[]
  >([]);

  const [allUpdatePartyData, setAllUpdatePartyData] = React.useState<any[]>([]);
  const [debitSubTotal, setDebitSubTotal] = React.useState<number>(0);
  const [creditSubTotal, setCreditSubTotal] = React.useState<number>(0);
  const [dateFiled, setDateFiled] = React.useState<any>();
  const [editDate, setEditDate] = useState<any>();

  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
  const [importModal, setImportModal] = React.useState<any>({
    type: "",
    param: {},
  });
  const [deleteUploadId, setDeleteUploadId] = React.useState<string[]>([]);
  const [previewImage, setPreviewImage] = React.useState<{
    isBaseConvert: boolean;
    path: any;
  }>({ isBaseConvert: false, path: "" });

  //change
  // const [showKeys, setShowKeys] = useState(false);

  // useHotkeys(
  //   "ctrl+shift",
  //   () => {
  //     setShowKeys((prev: any) => !prev);
  //   },
  //   {
  //     enabled: (event, hotkeysEvent) => {
  //       setTimeout(() => {
  //         setShowKeys(() => false);
  //         // alert("After 2 sec");
  //       }, 2000);

  //       return true;
  //     },
  //   }
  // );

  const [itmDropDownLoadinf, setItmDropDownLoading] = React.useState(false);

  // console.log("importData", location.state?.importData, allUpdatePartyData);

  useEffect(() => {
    if (location?.state?.importData) {
      const formattedData = location.state?.importData?.map((item: any) => ({
        id: {
          value: item.ledgerId,
          title: item?.partyOrTax,
        },
        credit: item?.credit,
        debit: item?.debit,
        // partyOrTax: item?.partyOrTax,
      }));
      form.setFieldsValue({
        partyLedger: [
          ...formattedData,
          { amount: "0.00", credit: "0.00", debit: "0.00" },
        ],
      });

      const debitTotal = location.state?.importData?.reduce(
        (total: any, item: any) => total + item.debit,
        0
      );
      setDebitSubTotal(debitTotal);
      const creditTotal = location.state?.importData?.reduce(
        (total: any, item: any) => total + item.credit,
        0
      );
      setCreditSubTotal(creditTotal);
    }
  }, [location, form]);

  // console.log("location.........", selectedBankBalance);
  // Date Api
  React.useEffect(() => {
    const getDate = async () => {
      if (currentClient?.id && !journalId) {
        await VoucherServices.getMaxVoucherDate(
          currentClient?.id!,
          Voucher_Type.Journal
        ).then((res) => {
          const givenDate = new Date(res?.result);
          const currentTime = new Date();

          // Set the time part of givenDate to match currentTime
          givenDate?.setHours(
            currentTime.getHours(),
            currentTime.getMinutes(),
            currentTime.getSeconds(),
            currentTime.getMilliseconds()
          );
          form.setFieldValue("date", dayjs(givenDate));

          setDateFiled(res.result);
        });
      }
    };
    getDate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id]);

  const getVoucherTitle = companySettings?.setting?.vouchersSettings.find(
    (x: vouchersSettings) => x?.settingType === SettingsSections.Journal
  );

  // ----- initial value -----
  React.useEffect(() => {
    if (currentClient?.id && !journalId && dateFiled) {
      setLoading(true);
      VoucherServices.getVoucherMaxNo(
        currentClient?.id!,
        Voucher_Type.Journal,
        dayjs(dateFiled).endOf("day").toISOString(),
        getVoucherTitle?.id!
      )
        .then((res) => {
          form.setFieldValue("number", res?.result);
          if (location?.state?.trialBalanceData) {
            // const trialBalanceData = location.state.trialBalanceData;
            const trialBalanceData = location?.state?.trialBalanceData?.map(
              (led: any) => {
                return {
                  id: led?.ledgerId,
                  debit: led?.debit,
                  credit: led?.credit,
                  title: led?.partyOrTax,
                };
              }
            );
            form?.setFieldsValue({
              partyLedger: trialBalanceData,
            });
            const debitTotal = trialBalanceData.reduce(
              (total: any, item: any) => total + item.debit,
              0
            );
            setDebitSubTotal(debitTotal);
            const creditTotal = trialBalanceData.reduce(
              (total: any, item: any) => total + item.credit,
              0
            );
            setCreditSubTotal(creditTotal);
          }
          setLoading(false);
        })
        .catch((err: any) => {
          openNotification("error", err.message);
          console.error(err.message);
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, dateFiled]);

  // party & other payment select
  React.useEffect(() => {
    setLoading(true);
    setItmDropDownLoading(true);
    LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes.Journal
    ).then((res) => {
      if (res) {
        // const onlyBank = res.filter(
        //   (x: any) => x.partyOrTax === 3 || x.partyOrTax === 2
        // );
        // setPartyLedgerOption(onlyBank);
        setPartyLedgerOption(res);
        setLoading(false);
        setItmDropDownLoading(false);
      } else {
        setLoading(false);
        setItmDropDownLoading(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  // Post (save) jornal api
  const save = (isSaveAndNew?: boolean, isDraft?: boolean) => {
    form.validateFields().then(async (val: any) => {
      console.log(
        "post",
        val,
        val.partyLedger.filter(
          (x: any) =>
            x?.id?.title === Party_Tax.BanknCash &&
            Utils.getNumber(x?.credit) > 0
        ),
        selectedBankBalance
      );
      setLoading(true);
      try {
        const allBankLedgerOnlyCreditAmount: any[] = val.partyLedger.filter(
          (x: any) =>
            x?.id?.title === Party_Tax.BanknCash &&
            Utils.getNumber(x?.credit) > 0
        );

        let bankBalanceLargeAmount: any = [];
        if (allBankLedgerOnlyCreditAmount.length > 0) {
          for (const index in allBankLedgerOnlyCreditAmount) {
            const bankLedgerBalance = selectedBankBalance.find(
              (x) => x?.id === allBankLedgerOnlyCreditAmount[index]?.id?.value
            )?.balance;
            if (
              Utils.getNumber(allBankLedgerOnlyCreditAmount[index]?.credit) >
              bankLedgerBalance
            ) {
              bankBalanceLargeAmount.push({
                name: allBankLedgerOnlyCreditAmount[index]?.id?.label,
                amount: bankLedgerBalance,
              });
              console.log("index", bankLedgerBalance);
            }
          }
        }

        if (bankBalanceLargeAmount.length > 0) {
          const formattedDetails = bankBalanceLargeAmount.map(
            (obj: any) =>
              `${obj?.name} -  Bank Amount: ₹ ${Utils.getFormattedNumber(
                obj?.amount
              )}`
          );
          alert(formattedDetails.join("\n"));
        } else {
          setSaveButtonLoading(true);

          const effectiveLedger: any[] = [];
          const partyLedger: any[] = [];
          val?.partyLedger?.map((x: any) => {
            if (parseFloat(x?.debit) > 0) {
              effectiveLedger.push({
                ...x,
                amount: x?.debit,
                id: x?.id?.value,
                partyOrTax: x?.id?.title,
                isDebitNature: true,
                ref:
                  x?.ref?.length > 0
                    ? x?.ref.map((x: any) => {
                        return {
                          ...x,
                          name: x?.name?.label ?? x?.name,
                          partyRef: x?.name?.value,
                        };
                      })
                    : null,
                depInvDetail:
                  x?.depInvDetail?.length > 0
                    ? x?.depInvDetail.map((x: any) => {
                        return {
                          ...x,
                          id: x?.name?.value,
                          name: x?.name?.label,
                          // partyRef: x?.name?.value,
                        };
                      })
                    : null,
              });
            } else {
              partyLedger.push({
                ...x,
                amount: x?.credit,
                id: x?.id?.value,
                partyOrTax: x?.id?.title,
                isDebitNature: false,
                ref:
                  x?.ref?.length > 0
                    ? x?.ref.map((x: any) => {
                        return {
                          ...x,
                          name: x?.name?.label ?? x?.name,
                          partyRef: x?.name?.value,
                        };
                      })
                    : null,
                depInvDetail:
                  x?.depInvDetail?.length > 0
                    ? x?.depInvDetail.map((x: any) => {
                        return {
                          ...x,
                          id: x?.name?.value,
                          name: x?.name?.label,
                          // partyRef: x?.name?.value,
                        };
                      })
                    : null,
              });
            }
          });

          let givenDate;
          if (journalId && dayjs(val?.date).isSame(dayjs(editDate), "day")) {
            givenDate = editDate;
          } else {
            givenDate = new Date(val.date);
            const currentTime = new Date();

            // Set the time part of givenDate to match currentTime
            givenDate?.setHours(
              currentTime.getHours(),
              currentTime.getMinutes(),
              currentTime.getSeconds(),
              currentTime.getMilliseconds()
            );
          }

          const data = {
            ...val,
            voucherTitle: {
              id: getVoucherTitle?.id,
              name: getVoucherTitle?.settings?.basicSettings?.titleToBePrint,
            },
            isCustomNumber:
              getVoucherTitle?.settings?.basicSettings?.manualNumbering,
            deleteUploadId: deleteUploadId,
            amount: totalPaymentIn,
            date: dayjs(givenDate).toISOString(),
            isLocked: false,
            isReconciled: false,
            isAudited: false,
            isActive: true,
            partyLedger: partyLedger,
            effectiveLedger: effectiveLedger,
            mode:
              location.state?.importData?.length > 0
                ? VoucherMode.Opening
                : VoucherMode.Normal,
          };

          const res = isDraft
            ? await DraftService.postVoucherDraft(
                currentClient?.id!,
                Voucher_Type.Journal,
                data,
                draftId
              )
            : await VoucherServices.postVoucher(
                currentClient?.id!,
                Voucher_Type.Journal,
                data,
                journalId
              );

          if (res?.status) {
            if (isDraft) {
              openNotification(
                "success",
                `Journal draft ${res.result?.name} ${
                  draftId ? "updated successfully." : "added successfully."
                }`
              );
            } else {
              openNotification(
                "success",
                `Journal ${
                  journalId ? "updated successfully." : "added successfully."
                }`
              );
              navigate(-1);
              setSaveButtonLoading(false);
            }
          } else if (res?.message) {
            openNotification("error", res?.message);
            setSaveButtonLoading(false);
            setLoading(false);
          }

          // .catch((ex) => {
          //   setSaveButtonLoading(false);
          //   openNotification("error", ex);
          // });
        }
      } catch (ex) {
        console.error("Error", ex);
        setSaveButtonLoading(false);
        setLoading(false);

        openNotification("error", ex);
      } finally {
        setLoading(false);
      }
    });
  };
  EntryLevelKeys({
    save: () => save(),
    cancel: () => navigate(-1),
  });

  const partySelect: any = async (
    partyId: string,
    index: number,
    title: Party_Tax,
    newLedgerAdd: boolean
  ) => {
    // all select id Store in this State
    setSelectedPartyOption((prevState) => {
      const updatedSelectedOptions = [...prevState];
      updatedSelectedOptions[index] = partyId;
      // console.log(updatedSelectedOptions);
      return updatedSelectedOptions;
    });

    // if (!journalId) {
    setSelectPartyRef((prevDataArray) => {
      const newArray = [...prevDataArray];
      if (index < 0 || index >= newArray.length) {
        newArray.push([]);
      } else {
        newArray.splice(index, 1, []);
      }
      return newArray;
    });

    setSelectAssetRef((prevDataArray) => {
      const newArray = [...prevDataArray];
      if (index < 0 || index >= newArray.length) {
        newArray.push([]);
      } else {
        newArray.splice(index, 1, []);
      }
      return newArray;
    });

    let onePartyUpdateData = allUpdatePartyData.find(
      (x) => x.id.value === partyId
    );
    console.log("onePartyUpdateData", onePartyUpdateData);

    if (title === Party_Tax.BanknCash) {
      if (newLedgerAdd) {
        updateTotals();
      }
      const bankLedger = partyLedgerOption.find((x) => x.id === partyId);
      // console.log("bankBalance", bankLedger.balance);
      setSelectedBankBalance((x: any) => {
        const updatedSelectedOptions = [...x];
        updatedSelectedOptions[index] = {
          id: bankLedger.id,
          balance:
            bankLedger?.balance +
            Math.abs(Utils.getNumber(onePartyUpdateData?.credit)),
        };
        return updatedSelectedOptions;
      });
    } else if (title === Party_Tax.party) {
      // update case if user delete reference & again add same reference
      if (journalId) {
        let onePartyUpdateData = allUpdatePartyData.find(
          (x) => x.id.value === partyId
        );

        console.log("onePartyUpdateData", onePartyUpdateData);

        if (onePartyUpdateData) {
          // yadi user ne pahle hi add kar raha & deleter kar ke again add
          form.setFieldValue(["partyLedger", index], {
            ...onePartyUpdateData,
          });

          setSelectPartyRef((prevState: any[]) => {
            const updatedSelectedOptions: any[] = [...prevState];
            updatedSelectedOptions[index] = [...(prevState[index] || [])];
            updatedSelectedOptions[index] = onePartyUpdateData?.ref?.map(
              (x: any) => x?.parentRef
            );
            return updatedSelectedOptions;
          });

          setPartyRef((prevDataArray) => {
            const newArray = [...prevDataArray];
            newArray[index] = onePartyUpdateData?.ref?.map((x: any) => {
              return {
                ...x,
                maxAmount: x?.value,
              };
            });
            return newArray;
          });
        }

        console.log("allUpdatePartyData", onePartyUpdateData);
      }

      await VoucherServices.getReferencesByParty(
        currentClient?.id!,
        partyId,
        Voucher_Type.Journal
      ).then((res: any) => {
        console.log("result", res.result?.length, index);
        if (res.result?.length > 0) {
          const data = res.result?.map((v: any, i: number) => {
            return {
              name: res.result[i]?.refNo,
              maxAmount: res.result[i]?.value,
              dueAmount: res.result[i]?.dueAmount,
              // id: res.result[i]?.id,
              parentRef: res.result[i]?.id,
              id: null,
              refType: 1,
            };
          });

          if (
            journalId &&
            allUpdatePartyData.find((x) => x.id?.value === partyId)
          ) {
            setPartyRef((prevDataArray) => {
              const prevArray = prevDataArray[index];
              // Filter out the common elements based on 'parentRefId'
              const filteredData = data.filter((newItem: any) => {
                return !prevArray?.some(
                  (prevItem: any) => prevItem?.parentRef === newItem?.parentRef
                );
              });
              const updatedArray = [...prevArray, ...filteredData];
              console.log("newArray", updatedArray);
              const newArray = [...prevDataArray];
              newArray[index] = updatedArray;
              return newArray;
            });
          } else {
            // debugger;
            form.setFieldValue(["partyLedger", index, "ref"], [{}]);
            if (newLedgerAdd) {
              const remainingAmount = updateTotals();
              // console.log("remainingAmount", remainingAmount);
              form.setFieldValue(["partyLedger", index, "ref", 0], {
                name: form.getFieldValue(["number"]),
                value: remainingAmount > 0 ? remainingAmount : 0,
                amount: 0,
                refType: 0,
              });
            } else {
              form.setFieldValue(["partyLedger", index, "ref", 0], {
                name: form.getFieldValue(["number"]),
                amount: 0,
                refType: 0,
              });
            }

            form.setFieldValue(["partyLedger", index, "ref", 1], {});

            setPartyRef((prevDataArray) => {
              const newArray = [...prevDataArray];
              newArray[index] = data;
              return newArray;
            });
          }
        } else if (!journalId) {
          form.setFieldValue(["partyLedger", index, "ref"], [{}]);
          if (newLedgerAdd) {
            const remainingAmount = updateTotals();
            // console.log("remainingAmount", remainingAmount);
            form.setFieldValue(["partyLedger", index, "ref", 0], {
              name: form.getFieldValue(["number"]),
              value: remainingAmount > 0 ? remainingAmount : 0,
              amount: 0,
              refType: 0,
            });
          } else {
            form.setFieldValue(["partyLedger", index, "ref", 0], {
              name: form.getFieldValue(["number"]),
              amount: 0,
              refType: 0,
            });
          }
          setPartyRef((prevDataArray) => {
            const newArray = [...prevDataArray];
            newArray[index] = [];
            return newArray;
          });
        }
      });
    } else if (title === Party_Tax.Depreciation) {
      if (newLedgerAdd) {
        updateTotals();
      }

      const assetLedger = partyLedgerOption.find((x) => x.id === partyId);

      if (journalId) {
        let oneAssetUpdateData = allUpdatePartyData.find(
          (x) => x.id.value === partyId
        );

        // console.log("onePartyUpdateData", oneAssetUpdateData);

        if (oneAssetUpdateData) {
          // yadi user ne pahle hi add kar raha & deleter kar ke again add
          form.setFieldValue(["partyLedger", index], {
            ...oneAssetUpdateData,
          });

          setSelectAssetRef((prevState: any[]) => {
            const updatedSelectedOptions: any[] = [...prevState];
            updatedSelectedOptions[index] = [...(prevState[index] || [])];
            updatedSelectedOptions[index] =
              oneAssetUpdateData?.depInvDetail?.map((x: any) => x?.name?.value);
            return updatedSelectedOptions;
          });

          const editData =
            oneAssetUpdateData?.depInvDetail?.length > 0 &&
            oneAssetUpdateData?.depInvDetail.map((x: any, refIndex: Number) => {
              const otherAssetLedDet = assetLedger?.asstInvDetail?.find(
                (y: any) => y.id === x?.id
              );
              // console.log(
              //   "assetLedger otherAssetLedDet",
              //   otherAssetLedDet,
              //   "depInvDetail",
              //   v?.depInvDetail
              // );

              return {
                ...x,
                accumulatedDepreciation:
                  otherAssetLedDet?.accumulatedDepreciation,
                adjust: otherAssetLedDet?.adjust,
                assetDetail: { ...otherAssetLedDet?.assetDetail },
                assetRef: otherAssetLedDet?.assetRef,
                availableQty: otherAssetLedDet?.availableQty,
                date: otherAssetLedDet?.date,
                // id: otherAssetLedDet?.id,
                isDepreciatedCurrentYear:
                  otherAssetLedDet?.isDepreciatedCurrentYear,
                returnedQty: otherAssetLedDet?.returnedQty,
                soldQty: otherAssetLedDet?.soldQty,
                status: otherAssetLedDet?.status,
                voucherRef: {
                  ...otherAssetLedDet?.voucherRef,
                },
              };
            });

          const filteredData = assetLedger?.asstInvDetail?.filter(
            (newItem: any) => {
              return !editData?.some(
                (prevItem: any) => prevItem?.id === newItem?.id
              );
            }
          );

          console.log("filteredData", filteredData);
          setAssetRef((prevDataArray) => {
            const newArray = [...prevDataArray];
            newArray[index] = [...editData, ...filteredData];
            return newArray;
          });

          // setAssetRef((prevDataArray) => {
          //   const newArray = [...prevDataArray];
          //   newArray[index] = onePartyUpdateData?.depInvDetail?.map(
          //     (x: any) => {
          //       return {
          //         ...x,
          //         qty: x?.value,
          //       };
          //     }
          //   );
          //   return newArray;
          // });
        }
      } else {
        console.log("assetLedger", assetLedger);

        form.setFieldValue(["partyLedger", index, "depInvDetail"], [{}]);

        setAssetRef((prevDataArray) => {
          const newArray = [...prevDataArray];
          newArray[index] = assetLedger?.asstInvDetail;
          return newArray;
        });
      }
    } else {
      if (newLedgerAdd) {
        updateTotals();
      }
      setPartyRef((prevDataArray) => {
        const newArray = [...prevDataArray];
        newArray[index] = [];
        return newArray;
      });
    }

    setDisabledAmountInputs((prev) => {
      const newDisabledInputs = [...prev];
      // newDisabledInputs[index] = title === Party_Tax.party ? true : false;
      newDisabledInputs[index] = title;
      return newDisabledInputs;
    });
    // }
    // handleLedgerNetAmount(index);
  };

  console.log("data");

  //  -------- Edit payment Get API ---------
  React.useEffect(() => {
    if ((journalId || draftId) && partyLedgerOption.length > 0) {
      const editData = async (journalId: string) => {
        setLoading(true);
        try {
          const res = draftId
            ? await DraftService.getByDraftId(currentClient?.id!, draftId)
            : await VoucherServices.getVoucharById(
                currentClient?.id!,
                journalId,
                Voucher_Type.Journal
              );
          if (res.result) {
            setIsVoucherLocked(res?.result?.isLocked);
            // setIsCustomNumber(res?.result?.isCustomNumber);
            // console.log("result.............................", res.result);
            setIsOpeningOrClosingVoucher(
              res?.result?.mode === VoucherMode.Opening ||
                res?.result?.mode === VoucherMode.Closing
            );
            setTotalPaymentIn(Math.abs(res.result?.effectiveLedger[0]?.amount));
            // console.log("result", [
            //   ...res.result?.effectiveLedger,
            //   ...res.result?.partyLedger,
            // ]);

            const x = [
              ...res.result?.effectiveLedger,
              ...res.result?.partyLedger,
            ];
            // console.log("x...........", x);

            // x?.map((x: any) => {
            //   let bankAccount = partyLedgerOption.find(
            //     (x: any) => x.id === x?.id
            //   );
            //   console.log(
            //     "Enter Details",
            //     // bankAccountList.find((x: any) => x.id === x?.id)
            //     Utils.getNumber(Math.abs(x?.amount)),
            //     bankAccount?.balance
            //   );
            //   // console.log("x........", x.date);

            //   setSelectedBankBalance((x: any) => [
            //     ...x,
            //     {
            //       id: bankAccount.id,
            //       balance:
            //         Utils.getNumber(Math.abs(x?.amount)) + bankAccount?.balance,
            //     },
            //   ]);
            // });

            const partyLedger = await Promise.all(
              x.map(async (v: any, partyIndex: number) => {
                // console.log("ref", v?.ref);

                let bankAccount = partyLedgerOption.find(
                  (y: any) => y.id === v?.id
                );
                console.log(
                  "Enter Details",
                  // bankAccountList.find((x: any) => x.id === x?.id)
                  v.amount,
                  Math.abs(v?.amount),
                  bankAccount?.balance,
                  Math.abs(bankAccount?.balance)
                );
                // console.log("x........", x.date);

                setSelectedBankBalance((x: any) => [
                  ...x,
                  {
                    id: v.id,
                    balance: Math.abs(v?.amount) + (bankAccount?.balance ?? 0),
                  },
                ]);

                // party ref set only
                if (v?.partyOrTax === Party_Tax.party) {
                  setSelectPartyRef((prevState: any[]) => {
                    const updatedSelectedOptions: any[] = [...prevState];
                    updatedSelectedOptions[partyIndex] = [
                      ...(prevState[partyIndex] || []),
                    ];
                    const pushNewElement = [null, ...v.ref]; // if refType not specified 0 (like new Ref type not avaliable)
                    updatedSelectedOptions[partyIndex] =
                      v?.ref[0]?.refType === 0
                        ? v?.ref?.map((x: any) => x.parentRef)
                        : pushNewElement?.map((x: any) => x?.parentRef);
                    // updatedSelectedOptions[partyIndex] =
                    //   v?.ref?.length > 0 &&
                    //   v?.ref?.map((x: any) => x.parentRef);
                    return updatedSelectedOptions;
                  });

                  setPartyRef((prevDataArray) => {
                    const newArray = [...prevDataArray];
                    newArray[partyIndex] =
                      v?.ref?.length > 0 &&
                      v?.ref.map((x: any, refIndex: Number) => {
                        return {
                          ...x,
                          maxAmount: x?.value,
                        };
                      });
                    return newArray;
                  });

                  // party New Ref.
                  await VoucherServices.getReferencesByParty(
                    currentClient?.id!,
                    v?.id,
                    Voucher_Type.Journal
                  ).then((res) => {
                    const data = res.result?.map((x: any, i: number) => {
                      return {
                        name: res.result[i]?.refNo,
                        maxAmount: res.result[i]?.value,
                        dueAmount: res.result[i]?.dueAmount,
                        // id: res.result[i]?.id,
                        parentRef: res.result[i]?.id,
                        id: null,
                        refType: 1,
                      };
                    });

                    setPartyRef((prevDataArray) => {
                      const prevArray = prevDataArray[partyIndex];
                      // Filter out the common elements based on 'id'
                      // console.log("data", data);
                      // console.log("prevArray", prevArray);

                      const filteredData = data?.filter((newItem: any) => {
                        return !prevArray?.some(
                          (prevItem: any) =>
                            prevItem?.parentRef === newItem?.parentRef
                        );
                      });
                      const updatedArray = [...prevArray, ...filteredData];
                      // console.log("newArray", updatedArray);
                      const newArray = [...prevDataArray];
                      newArray[partyIndex] = updatedArray;
                      return newArray;
                    });
                  });
                } else if (v?.partyOrTax === Party_Tax.Depreciation) {
                  // partyLedgerOption

                  // console.log("assetRef", v?.depInvDetail);

                  const ledger = partyLedgerOption?.find((x) => x.id === v?.id);

                  // console.log("assetLedger", ledger?.asstInvDetail);
                  const editData =
                    v?.depInvDetail?.length > 0 &&
                    v?.depInvDetail?.map((x: any, refIndex: Number) => {
                      const otherAssetLedDet = ledger?.asstInvDetail?.find(
                        (y: any) => y.id === x?.id
                      );
                      // console.log(
                      //   "assetLedger otherAssetLedDet",
                      //   otherAssetLedDet,
                      //   "depInvDetail",
                      //   v?.depInvDetail
                      // );

                      return {
                        ...x,
                        accumulatedDepreciation:
                          otherAssetLedDet?.accumulatedDepreciation,
                        adjust: otherAssetLedDet?.adjust,
                        assetDetail: { ...otherAssetLedDet?.assetDetail },
                        assetRef: otherAssetLedDet?.assetRef,
                        availableQty: otherAssetLedDet?.availableQty,
                        date: otherAssetLedDet?.date,
                        // id: otherAssetLedDet?.id,
                        isDepreciatedCurrentYear:
                          otherAssetLedDet?.isDepreciatedCurrentYear,
                        returnedQty: otherAssetLedDet?.returnedQty,
                        soldQty: otherAssetLedDet?.soldQty,
                        status: otherAssetLedDet?.status,
                        voucherRef: {
                          ...otherAssetLedDet?.voucherRef,
                        },
                      };
                    });

                  const filteredData = ledger?.asstInvDetail?.filter(
                    (newItem: any) => {
                      return !editData?.some(
                        (prevItem: any) => prevItem?.id === newItem?.id
                      );
                    }
                  );

                  // console.log("filteredData", filteredData);
                  setAssetRef((prevDataArray) => {
                    const newArray = [...prevDataArray];
                    newArray[partyIndex] = [...editData, ...filteredData];
                    return newArray;
                  });

                  setSelectAssetRef((prevState: any[]) => {
                    const updatedSelectedOptions: any[] = [...prevState];
                    updatedSelectedOptions[partyIndex] = [
                      ...(prevState[partyIndex] || []),
                    ];
                    updatedSelectedOptions[partyIndex] = v?.depInvDetail?.map(
                      (x: any) => x?.id
                    );
                    return updatedSelectedOptions;
                  });
                } else {
                  setPartyRef((prevDataArray) => {
                    const newArray = [...prevDataArray];
                    newArray[partyIndex] = [];
                    return newArray;
                  });
                  setAssetRef((prevDataArray) => {
                    const newArray = [...prevDataArray];
                    newArray[partyIndex] = [];
                    return newArray;
                  });
                  setSelectPartyRef((prevState: any[]) => {
                    const updatedSelectedOptions: any[] = [...prevState];
                    updatedSelectedOptions[partyIndex] = [];
                    return updatedSelectedOptions;
                  });
                  setSelectAssetRef((prevState: any[]) => {
                    const updatedSelectedOptions: any[] = [...prevState];
                    updatedSelectedOptions[partyIndex] = [];
                    return updatedSelectedOptions;
                  });
                }

                setDisabledAmountInputs((prev) => {
                  const newDisabledInputs = [...prev];
                  // newDisabledInputs[partyIndex] =
                  //   v.partyOrTax === Party_Tax.party ? true : false;
                  newDisabledInputs[partyIndex] = v.partyOrTax;
                  // console.log(newDisabledInputs);
                  return newDisabledInputs;
                });
                setSelectedPartyOption((prevState) => {
                  const updatedSelectedOptions = [...prevState];
                  updatedSelectedOptions[partyIndex] = v?.id;
                  return updatedSelectedOptions;
                });

                return {
                  ...v,
                  // ref:
                  // v?.ref[0]?.refType === 0
                  //   ? [...v?.ref, {}]
                  //   : [
                  //       { refType: 0, name: res?.result?.number },
                  //       ...v?.ref,
                  //       {},
                  //     ],
                  ref:
                    v?.ref?.length > 0
                      ? v?.ref[0]?.refType === 0
                        ? [
                            ...v?.ref?.map((x: any) => {
                              return {
                                ...x,
                                maxAmount: Utils.getNumber(x?.value),
                                value: x?.value,
                                dueAmount: x?.dueAmount,
                              };
                            }),
                            {},
                          ]
                        : [
                            { refType: 0, name: res?.result?.number },
                            ...v?.ref?.map((x: any) => {
                              return {
                                ...x,
                                maxAmount: Utils.getNumber(x?.value),
                                value: x?.value,
                                dueAmount: x?.dueAmount,
                              };
                            }),
                            {},
                          ]
                      : [],
                  depInvDetail:
                    v?.depInvDetail?.length > 0
                      ? [
                          ...v?.depInvDetail?.map((x: any) => {
                            return {
                              ...x,
                              name: {
                                value: x?.id,
                                label: x?.name,
                              },
                            };
                          }),
                          {},
                        ]
                      : [],
                  debit: v?.isDebitNature ? Math.abs(v?.amount) : "0.00",
                  credit: !v?.isDebitNature ? Math.abs(v?.amount) : "0.00",
                  id: {
                    value: v?.id,
                    label: v?.ledgerName,
                    title: v?.partyOrTax,
                  },
                };
              })
            );

            console.log("partyLedger", partyLedger[0].ref);
            if (partyLedger) {
              form.setFieldsValue({
                ...res.result,
                partyLedger: [...partyLedger, { debit: 0.0, credit: 0.0 }],
                date: dayjs(res.result?.date),
              });
            }
            setEditDate(res.result?.date);
            setDebitSubTotal(res.result?.amountSummary?.totalInvoiceAmount);
            setCreditSubTotal(res.result?.amountSummary?.totalInvoiceAmount);

            setAccountIsParty(res.result?.effectiveLedger[0]?.partyOrTax);
            setAllUpdatePartyData([...partyLedger]);

            setLoading(false);
          }
        } catch (err: any) {
          openNotification("error", err.message);
          console.error("error..", err.message);
          setLoading(false);
        } finally {
          setLoading(false);
        }
      };

      editData(journalId! ?? draftId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [journalId, partyLedgerOption, draftId]);

  const handleLedgerNetAmount = (index: number) => {
    // console.log(
    //   "false.............",
    //   form.getFieldValue(["partyLedger", index])?.id?.title
    // );
    let partyLedgerlist = form.getFieldValue(["partyLedger"]);
    const currentPartyLedgerIndexData = partyLedgerlist[index];

    // console.log("currentPartyLedgerIndexData", currentPartyLedgerIndexData);

    form.setFieldValue(["partyLedger", index], {
      ...currentPartyLedgerIndexData,
      amount: currentPartyLedgerIndexData?.ref.reduce(
        (acc: number, curr: any) => {
          return (acc += Utils.getNumber(curr?.value));
        },
        0
      ),
    });

    handleAllLedgerValue();

    return 0;
  };

  const handleAllLedgerValue = () => {
    let partyLedgerlist = form.getFieldValue(["partyLedger"]);
    // console.log("partyLedgerlist", partyLedgerlist);

    const x = partyLedgerlist.reduce((acc: number, curr: any) => {
      return (acc += Utils.getNumber(curr?.amount));
    }, 0);
    // console.log("ccccccccccccccc.c.c.c.c.", x);
    setTotalPaymentIn(x);
  };

  // asset functions
  const checkAssetRefValidation = (partyIndex: number) => {
    const debitAmount = Utils.getNumber(
      form.getFieldValue(["partyLedger", partyIndex, "debit"])
    );

    const creditAmount = Utils.getNumber(
      form.getFieldValue(["partyLedger", partyIndex, "credit"])
    );

    const totalAmount = Utils.getNumber(
      form
        .getFieldValue(["partyLedger", partyIndex, "depInvDetail"])
        .reduce((acc: number, curr: any) => {
          return (acc += Utils.getNumber(curr?.value));
        }, 0)
    );

    if (debitAmount > 0 && debitAmount !== totalAmount) {
      form.setFields([
        {
          name: ["partyLedger", partyIndex, "debit"],
          errors: ["Reference amount do not match!"],
        },
      ]);
    } else if (creditAmount > 0 && creditAmount !== totalAmount) {
      form.setFields([
        {
          name: ["partyLedger", partyIndex, "credit"],
          errors: ["Reference amount do not match!"],
        },
      ]);
    } else {
      form.setFields([
        {
          name: ["partyLedger", partyIndex, "debit"],
          errors: [],
        },
        {
          name: ["partyLedger", partyIndex, "credit"],
          errors: [],
        },
      ]);
    }
  };

  const onChageAssetRef = (
    value: string,
    partyIndex: number,
    isParty: boolean,
    refIndex?: number
  ) => {
    debugger;
    if (refIndex === 0 || refIndex) {
      // remove one asset ref in index - click cross icons
      setSelectAssetRef((prevDataArray) => {
        const newArray = [...prevDataArray];
        newArray[partyIndex] = [...(prevDataArray[partyIndex] || [])];
        newArray[partyIndex].splice(refIndex, 1);
        return newArray;
      });
      checkAssetRefValidation(partyIndex);
    }
  };

  const onChangeSetAssetRef = (
    partyIndex: number,
    refIndex: number,
    assetRefId: string
  ) => {
    // debugger;
    const x = assetRef[partyIndex].find((x: any) => x.id === assetRefId);
    console.log("data........", x);
    if (journalId) {
      form.setFieldValue(
        ["partyLedger", partyIndex, "depInvDetail", refIndex],
        {
          ...x,
          qty: x?.availableQty,
          name: {
            value: x?.id,
            label: x?.name ?? x?.voucherRef?.name,
          },
          value: x?.value,
        }
      );
    } else {
      form.setFieldValue(
        ["partyLedger", partyIndex, "depInvDetail", refIndex, "qty"],
        // {
        //   ...x,
        x?.availableQty
        // }
      );
    }
    setSelectAssetRef((prevState: any[]) => {
      const updatedSelectedOptions: any[] = [...prevState];
      console.log("setSelectPartyRef.....", updatedSelectedOptions);
      updatedSelectedOptions[partyIndex] = [...(prevState[partyIndex] || [])];
      updatedSelectedOptions[partyIndex][refIndex] = assetRefId;
      return updatedSelectedOptions;
    });
  };

  // party functions
  const onChangeSetPartyRef = async (
    partyIndex: number,
    refIndex: number,
    partyRefId: string
  ) => {
    // console.log("ref.....onChangeSetPartyRef.", selectPartyRef);
    const x = partyRef[partyIndex].find((x: any) => x.parentRef === partyRefId);
    // console.log("data........", x);

    if (journalId) {
      form.setFieldValue(["partyLedger", partyIndex, "ref", refIndex], {
        ...x,
        value: x.value ?? 0.0,
        dueAmount: x?.dueAmount,
      });
    } else {
      const partyIndexAmount =
        Utils.getNumber(
          form.getFieldValue(["partyLedger", partyIndex, "debit"])
        ) > 0
          ? Utils.getNumber(
              form.getFieldValue(["partyLedger", partyIndex, "debit"])
            )
          : Utils.getNumber(
              form.getFieldValue(["partyLedger", partyIndex, "credit"])
            );
      const remainingRefAmount = Utils.getNumber(
        form
          .getFieldValue(["partyLedger", partyIndex, "ref"])
          .slice(1)
          .filter((_: any, idx: number) => idx !== refIndex)
          .reduce((acc: number, curr: any) => {
            return (acc += Utils.getNumber(curr?.value));
          }, 0)
      );
      let dueAmount;
      if (partyIndexAmount - (remainingRefAmount + x.dueAmount) < 0) {
        dueAmount = partyIndexAmount - remainingRefAmount;
      } else {
        dueAmount = x.dueAmount;
      }
      console.log(
        "partyIndexAmount",
        partyIndexAmount,
        "remainingRefAmount",
        remainingRefAmount
      );

      form.setFieldValue(["partyLedger", partyIndex, "ref", refIndex], {
        ...x,
        value: dueAmount,
      });
      if (dueAmount > 0) {
        form.setFields([
          {
            name: ["partyLedger", partyIndex, "ref", refIndex, "value"],
            errors: [],
          },
        ]);
      }
    }

    setSelectPartyRef((prevState: any[]) => {
      const updatedSelectedOptions: any[] = [...prevState];
      console.log("setSelectPartyRef.....", updatedSelectedOptions);
      updatedSelectedOptions[partyIndex] = [...(prevState[partyIndex] || [])];
      updatedSelectedOptions[partyIndex][refIndex] = partyRefId;
      return updatedSelectedOptions;
    });

    onChangeRefAmountSet(x.dueAmount, partyIndex, false);
  };

  const onChangeRefAmountSet = (
    value: string,
    partyIndex: number,
    isParty: boolean,
    refIndex?: number
  ) => {
    console.log("ref..........", selectPartyRef, partyIndex, refIndex);
    // debugger
    if (refIndex) {
      // remove one party ref in index - click cross icons
      setSelectPartyRef((prevDataArray) => {
        const newArray = [...prevDataArray];
        newArray[partyIndex] = [...(prevDataArray[partyIndex] || [])];
        newArray[partyIndex].splice(refIndex, 1);
        return newArray;
      });
    }

    if (isParty) {
      disabledAmountInputs[partyIndex] === Party_Tax.party &&
        form.setFieldValue(
          ["partyLedger", partyIndex, "ref", 0, "value"],
          Utils.getNumber(value) -
            Utils.getNumber(
              form
                .getFieldValue(["partyLedger", partyIndex, "ref"])
                .slice(1)
                .reduce((acc: number, curr: any) => {
                  return (acc += Utils.getNumber(curr?.value));
                }, 0)
            )
        );
    } else {
      disabledAmountInputs[partyIndex] === Party_Tax.party &&
        form.setFieldValue(
          ["partyLedger", partyIndex, "ref", 0, "value"],
          Utils.getNumber(
            Utils.getNumber(
              form.getFieldValue(["partyLedger", partyIndex, "debit"])
            ) > 0
              ? form.getFieldValue(["partyLedger", partyIndex, "debit"])
              : form.getFieldValue(["partyLedger", partyIndex, "credit"])
          ) -
            Utils.getNumber(
              form
                .getFieldValue(["partyLedger", partyIndex, "ref"])
                .slice(1)
                .reduce((acc: number, curr: any) => {
                  return (acc += Utils.getNumber(curr?.value));
                }, 0)
            )
        );
    }
  };

  // console.log("post", selectAssetRef, assetRef);

  const handleTotalChange = (itemList: any) => {
    // Calculate the total credit and update state
    const TotalCredit = itemList.reduce((acc: number, curr: any) => {
      return (acc += Utils.getNumber(curr?.credit));
    }, 0);
    setCreditSubTotal(TotalCredit);

    // Calculate the total credit and update state
    const TotalDebit = itemList.reduce((acc: number, curr: any) => {
      return (acc += Utils.getNumber(curr?.debit));
    }, 0);
    setDebitSubTotal(TotalDebit);
  };

  const onCreditBlur = (val: string, index: number) => {
    // debugger;
    const itemList = form.getFieldValue(["partyLedger"]);
    const updatedItems = [...itemList];
    console.log("val", val);
    if (Utils.getNumber(val) !== 0) {
      updatedItems[index].debit = Utils.getFormattedNumber(0);
    }
    updatedItems[index].credit = Utils.getFormattedNumber(Utils.getNumber(val));
    form.setFieldValue("partyLedger", updatedItems);
    form.validateFields([["partyLedger", index, "debit"]]);
    handleTotalChange(updatedItems);
  };

  const onDebitBlur = (val: string, index: number) => {
    const itemList = form.getFieldValue(["partyLedger"]);
    const updatedItems = [...itemList];
    console.log("val", val);
    if (Utils.getNumber(val) !== 0) {
      updatedItems[index].credit = Utils.getFormattedNumber(0);
    }
    updatedItems[index].debit = Utils.getFormattedNumber(Utils.getNumber(val));
    form.setFieldValue("partyLedger", updatedItems);
    form.validateFields([["partyLedger", index, "credit"]]);
    handleTotalChange(updatedItems);
  };

  const debitRefs: any = useRef([]);
  const creditRefs: any = useRef([]);

  const updateTotals = () => {
    const currentFields = form.getFieldValue("partyLedger") || [];
    const nonNullFields = currentFields.filter(
      (item: any) => item !== null && item !== undefined
    );

    const totalDebit = nonNullFields.reduce(
      (sum: number, item: any) => sum + Utils.getNumber(item.debit),
      0
    );

    const totalCredit = nonNullFields.reduce(
      (sum: number, item: any) => sum + Utils.getNumber(item.credit),
      0
    );

    const remainingDebit = totalCredit - totalDebit;
    const remainingCredit = totalDebit - totalCredit;
    const lastIndex = currentFields.length - 2;

    const updatedFields = [...currentFields];

    if (updatedFields.length > 2) {
      if (remainingDebit > 0) {
        debitRefs.current[lastIndex].select();
        updatedFields[lastIndex] = {
          ...updatedFields[lastIndex],
          debit: remainingDebit,
          credit: "0.00",
        };
      } else if (remainingCredit > 0) {
        creditRefs.current[lastIndex].select();
        updatedFields[lastIndex] = {
          ...updatedFields[lastIndex],
          credit: remainingCredit,
          debit: "0.00",
        };
      } else {
        debitRefs.current[lastIndex].select();
        updatedFields[lastIndex] = {
          ...updatedFields[lastIndex],
          debit: "0.00",
          credit: "0.00",
        };
      }
      form.setFieldsValue({ partyLedger: updatedFields });
      handleTotalChange(updatedFields);
      return remainingDebit > 0 ? remainingDebit : remainingCredit;
    } else {
      updatedFields[lastIndex] = {
        ...updatedFields[lastIndex],
        debit: "0.00",
        credit: "0.00",
      };
      form.setFieldsValue({ partyLedger: updatedFields });
      debitRefs.current[lastIndex].select();
      return 0;
    }
  };

  const focusOnvalue = (i: number) => {
    const currentFields = [...form.getFieldValue("partyLedger")];
    if (currentFields[i]?.debit > currentFields[i]?.credit) {
      debitRefs.current[i].select();
    } else if (currentFields[i]?.credit > currentFields[i]?.debit) {
      creditRefs.current[i].select();
    } else {
      debitRefs.current[i].select();
    }
  };
  const [addLedgerResponse, setAddLedgerResponse] = useState<any>(null);

  useEffect(() => {
    try {
      if (addLedgerResponse) {
        const exists = partyLedgerOption?.some(
          (option: any) => option.id === addLedgerResponse.id
        );
        console.log("newAdd", addLedgerResponse, exists);

        if (exists) {
          let partyLedger = [...(form?.getFieldValue("partyLedger") || [])];
          partyLedger.pop();
          partyLedger.push({
            credit: 0.0,
            debit: 0.0,
            amount: 0,
            id: {
              label: addLedgerResponse?.ledgerName,
              value: addLedgerResponse.id,
              key: addLedgerResponse.id,
              title: addLedgerResponse.partyOrTax,
            },
          });
          partyLedger.push({
            credit: "0.00",
            debit: "0.00",
            amount: "0.00",
            id: {},
          });
          const index = partyLedger.findIndex(
            (ledgerArray) => ledgerArray?.id?.value === addLedgerResponse.id
          );
          form.setFieldValue("partyLedger", partyLedger);
          // updateTotals();
          partySelect(
            addLedgerResponse.id,
            index,
            addLedgerResponse.ledgerName,
            true
          );

          setAddLedgerResponse(null);
        }
      }
    } catch (error) {
      console.log("error", error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partyLedgerOption]);

  console.log("dataa", form.getFieldValue(["partyLedger"]));

  const permissionLedgerAdd = findUserOnlyOnePremission(
    "Master.Ledger.Add",
    clientSpecificRole(),
    currentClient?.id
  );

  return (
    <>
      <Card
        // size="small"
        // className="TableCard"
        style={{
          boxShadow: "0px 0px 10px 0px #96A1C84D",
          marginTop: 7,
          paddingTop: "5px",
        }}
        title={
          <>
            <div className="fs-20 fw-200 themeColor">Journal</div>
          </>
        }
      >
        <Spin indicator={antIcon} spinning={loading}>
          <Form
            form={form}
            name="paymentIn"
            disabled={isOpeningOrClosingVoucher || isVoucherLocked}
            autoComplete="off"
            initialValues={{
              partyLedger: [{ amount: "0.00", credit: "0.00", debit: "0.00" }],
              date: dayjs(),
            }}
            requiredMark={true}
          >
            {/* <Row justify="space-between">
              <Col span={11}>
                <Row gutter={[14, 10]}>
                  <Col span={7}>
                    <span className=" fw-500">Date</span>
                    <Form.Item
                      name="date"
                      className="m-0"
                      rules={[
                        {
                          required: true,
                          message: "Select Date",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format="DD/MM/YYYY"
                        onChange={(val) => {
                          setDateFiled(dayjs(val).toISOString());
                        }}
                        // disabledDate={(current) =>
                        //   current && current > dayjs().endOf("day")
                        // }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={7}>
                    <span className=" fw-500">Journal No.</span>
                    <Form.Item
                      name="number"
                      className="m-0"
                      rules={[
                        {
                          required: true,
                          message: "Please enter No.",
                        },
                      ]}
                    >
                      <Input disabled />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row> */}
            {isOpeningOrClosingVoucher && (
              <Row>
                <Col span={24}>
                  <div
                    style={{
                      textAlign: "center",
                      padding: "6px",
                      border: "solid 1px whitesmoke",
                      marginBottom: "7px",
                    }}
                  >
                    <p style={{ color: "#FF3800" }}>
                      Opening entry can be modified only from Settings
                    </p>
                  </div>
                </Col>
              </Row>
            )}
            <Row gutter={10}>
              <Col xl={12} lg={10} sm={24}>
                <Row gutter={10}>
                  <Col sm={12} xs={24}>
                    {/* <span className=" fw-500">Date</span> */}
                    <Form.Item
                      name="date"
                      label="Date"
                      className="m-0"
                      rules={[
                        {
                          required: true,
                          message: "Please Select date",
                        },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format="DD/MM/YYYY"
                        autoFocus
                        onChange={(val) => {
                          setDateFiled(dayjs(val).toISOString());
                        }}
                        disabledDate={(current: any) =>
                          current < dayjs(currentClient?.financialYearBegin) ||
                          current >=
                            dayjs(currentClient?.financialYearBegin).add(
                              2,
                              "year"
                            )
                        }

                        // disabledDate={(current) =>
                        //   current && current > dayjs().endOf("day")
                        // }
                      />
                    </Form.Item>
                  </Col>
                  <Col sm={12} xs={24}>
                    <Form.Item
                      name="number"
                      label="Journal No."
                      className="m-0"
                      rules={[
                        {
                          required: true,
                          message: "Please Enter Journal No.",
                        },
                      ]}
                    >
                      <Input
                        disabled={
                          !getVoucherTitle?.settings?.basicSettings
                            ?.manualNumbering
                        }
                        placeholder="Enter voucher No."
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div style={{ overflowY: "auto" }}>
              <table
                className="AddPageTabelDesign"
                style={{ fontSize: windowWidth <= 1024 ? "10.3px" : "" }}
              >
                <thead>
                  <tr>
                    <th style={{ width: "5%" }} className="textCenter">
                      S.No.
                    </th>

                    <th
                      style={{
                        width: "55%",
                        borderLeft: "1px solid rgb(240, 245, 255)",
                      }}
                      className="textStart ps-6"
                    >
                      Name
                    </th>

                    <th style={{ width: "20%" }} className="textStart ps-6">
                      Debit
                    </th>

                    <th
                      colSpan={2}
                      style={{ width: "20%" }}
                      className="textStart ps-6"
                    >
                      Credit
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <Form.List name="partyLedger">
                    {(fields, { add, remove, move }) => {
                      return (
                        <>
                          {confirmation && (
                            <ConfirmationModal
                              open={confirmation}
                              // "${form.getFieldValue(["items"])}"
                              text={`Do you really want to delete this ledger "${form.getFieldValue(
                                [
                                  "partyLedger",
                                  deleteItemList?.name,
                                  "id",
                                  "label",
                                ]
                              )}" ?`}
                              onNo={() => setConfirmation(false)}
                              onYes={() => {
                                onDebitBlur("0.0", deleteItemList.index);
                                onCreditBlur("0.0", deleteItemList.index);
                                remove(deleteItemList.name);
                                handleAllLedgerValue();
                                setItemLength(fields.length - 2);
                                setConfirmation(false);
                                setSelectedBankBalance((x: any) => {
                                  const allBankAmount = [...x];
                                  allBankAmount.splice(deleteItemList.name, 1);
                                  return allBankAmount;
                                });
                                setPartyRef((prev) => {
                                  const allPrevArray = [...prev];
                                  // console.log(
                                  //   "allPrevArray----------",
                                  //   allPrevArray,
                                  //   deleteItemList.index
                                  // );
                                  allPrevArray.splice(deleteItemList.index, 1);
                                  return allPrevArray;
                                });

                                setAssetRef((prev) => {
                                  const allPrevArray = [...prev];
                                  allPrevArray.splice(deleteItemList.index, 1);
                                  return allPrevArray;
                                });

                                setSelectPartyRef((prev: any[]) => {
                                  const allPrevReference = [...prev];
                                  allPrevReference.splice(
                                    deleteItemList.index,
                                    1
                                  );
                                  return allPrevReference;
                                });

                                setSelectAssetRef((prev: any[]) => {
                                  const allPrevAssetReference = [...prev];
                                  allPrevAssetReference.splice(
                                    deleteItemList.index,
                                    1
                                  );
                                  return allPrevAssetReference;
                                });

                                setDisabledAmountInputs((prev) => {
                                  const newDisabledInputs = [...prev];
                                  // console.log(
                                  //   "newDisabledInputs",
                                  //   newDisabledInputs
                                  // );
                                  newDisabledInputs.splice(
                                    deleteItemList.index,
                                    1
                                  );
                                  return newDisabledInputs;
                                });

                                setSelectedPartyOption((prev) => {
                                  const newDisabledInputs = [...prev];
                                  newDisabledInputs.splice(
                                    deleteItemList.index,
                                    1
                                  );
                                  return newDisabledInputs;
                                });
                              }}
                            />
                          )}
                          {fields.map(({ key, name, ...restField }, index1) => {
                            const isInputDisabled =
                              disabledAmountInputs[index1] ===
                                Party_Tax.party ||
                              disabledAmountInputs[index1] ===
                                Party_Tax.Depreciation;
                            return (
                              <>
                                <tr key={key}>
                                  <td>
                                    {fields.length !== index1 + 1 && (
                                      <div className="ps-10">{index1 + 1}.</div>
                                    )}
                                  </td>

                                  <td>
                                    <Form.Item
                                      name={[name, "id"]}
                                      className="m-0"
                                      {...restField}
                                    >
                                      <Select
                                        labelInValue
                                        showSearch
                                        bordered={false}
                                        loading={itmDropDownLoadinf}
                                        variant="filled"
                                        placeholder="Search for ledger"
                                        className="variantFilledSelect"
                                        optionFilterProp="children"
                                        popupMatchSelectWidth={false}
                                        style={{
                                          width: "100%",
                                          backgroundColor: "#FFFFFF",
                                        }}
                                        dropdownStyle={{ width: "250px" }}
                                        placement="bottomRight"
                                        // onSearch={(value: string) =>
                                        //   setSearchItem(value)
                                        // }

                                        options={partyLedgerOption
                                          .filter(
                                            (option) =>
                                              !selectedPartyOption.includes(
                                                option.id
                                              )
                                          )
                                          .map((option: any) => ({
                                            value: option?.id,
                                            label: option?.ledgerName.concat(
                                              option?.aliasName
                                                ? `${
                                                    " (" +
                                                    option?.aliasName +
                                                    ")"
                                                  }`
                                                : ""
                                            ),
                                            title: option?.partyOrTax,
                                          }))}
                                        filterOption={(input, option) =>
                                          (option?.label?.toString() ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                        onChange={(e: any) => {
                                          // console.log(
                                          //   "form",
                                          //   form.getFieldsValue(),
                                          //   partyLedgerOption.filter(
                                          //     (x: any) =>
                                          //       x.partyOrTax ===
                                          //       Party_Tax.BanknCash
                                          //   )
                                          // );
                                          const isAdd =
                                            fields.length === index1 + 1;

                                          if (isAdd) {
                                            add();
                                            // updateTotals();
                                          } else {
                                            focusOnvalue(index1);
                                          }
                                          partySelect(
                                            e.value,
                                            index1,
                                            e.title,
                                            isAdd
                                          );
                                        }}
                                        dropdownRender={(customerOptions) => (
                                          <>
                                            {customerOptions}
                                            {permissionLedgerAdd && (
                                              <>
                                                <Divider
                                                  style={{ margin: "5px 0px" }}
                                                />
                                                <Button
                                                  style={{ width: "100%" }}
                                                  icon={<PlusOutlined />}
                                                  type="link"
                                                  onClick={() => {
                                                    setOpenModel({
                                                      type: "addLedger",
                                                      param: {
                                                        open: true,
                                                      },
                                                    });
                                                    // setEditParty({ id: "" });
                                                  }}
                                                >
                                                  New Ledger
                                                </Button>
                                              </>
                                            )}
                                          </>
                                        )}
                                      />
                                    </Form.Item>
                                  </td>

                                  <td>
                                    <Form.Item
                                      className="m-0"
                                      {...restField}
                                      name={[name, "debit"]}
                                      rules={[
                                        ({ getFieldValue }) => ({
                                          validator(_, value) {
                                            // debugger;
                                            if (
                                              fields.length !== index1 + 1 &&
                                              isInputDisabled &&
                                              value > 0 &&
                                              getFieldValue([
                                                "partyLedger",
                                                index1,
                                                "id",
                                              ]).title ===
                                                Party_Tax.Depreciation
                                            ) {
                                              if (
                                                Utils.getNumber(
                                                  value
                                                  // getFieldValue([
                                                  //   "partyLedger",
                                                  //   index1,
                                                  //   "amount",
                                                  // ])
                                                ) !==
                                                Utils.getNumber(
                                                  getFieldValue([
                                                    "partyLedger",
                                                    index1,
                                                    "depInvDetail",
                                                  ]).reduce(
                                                    (
                                                      acc: number,
                                                      curr: any
                                                    ) => {
                                                      return (acc +=
                                                        Utils.getNumber(
                                                          curr?.value
                                                        ));
                                                    },
                                                    0
                                                  )
                                                )
                                              ) {
                                                return Promise.reject(
                                                  new Error(
                                                    "Reference amount do not match!"
                                                  )
                                                );
                                              } else {
                                                return Promise.resolve();
                                              }
                                            } else {
                                              return Promise.resolve();
                                            }
                                          },
                                        }),
                                      ]}
                                    >
                                      <Input
                                        // disabled={isInputDisabled}
                                        // prefix="&#8377;"
                                        disabled={
                                          isOpeningOrClosingVoucher ||
                                          fields.length === index1 + 1
                                        }
                                        bordered={false}
                                        variant="filled"
                                        defaultValue="0.00"
                                        ref={(el) =>
                                          (debitRefs.current[index1] = el)
                                        }
                                        step={0.0}
                                        style={{
                                          backgroundColor:
                                            fields.length === index1 + 1
                                              ? `${themeData.themeData?.themeColor}40`
                                              : "#FFFFFF",
                                        }}
                                        onBlur={(e) => {
                                          // handleAllLedgerValue();

                                          onDebitBlur(e.target.value, index1);
                                          Number(e.target.value) > 0 &&
                                            onChangeRefAmountSet(
                                              e.target.value,
                                              index1,
                                              true
                                            );

                                          // handelAmountChange(
                                          //   Utils.getNumber(e.target.value),
                                          //   index
                                          // );
                                          // getAllocatedAmount(Utils.getNumber(e.target.value));
                                        }}
                                        onChange={(e) => {
                                          onChangeRefAmountSet(
                                            e.target.value,
                                            index1,
                                            true
                                          );
                                        }}
                                        onFocus={(e) => {
                                          handleInputFocus(e, form);
                                        }}
                                      />
                                    </Form.Item>
                                  </td>

                                  <td>
                                    <Form.Item
                                      className="m-0"
                                      {...restField}
                                      name={[name, "credit"]}
                                      rules={[
                                        ({ getFieldValue }) => ({
                                          validator(_, value) {
                                            // debugger;
                                            if (
                                              fields.length !== index1 + 1 &&
                                              isInputDisabled &&
                                              value > 0 &&
                                              getFieldValue([
                                                "partyLedger",
                                                index1,
                                                "id",
                                              ]).title ===
                                                Party_Tax.Depreciation
                                            ) {
                                              if (
                                                Utils.getNumber(
                                                  value
                                                  // getFieldValue([
                                                  //   "partyLedger",
                                                  //   index1,
                                                  //   "amount",
                                                  // ])
                                                ) !==
                                                Utils.getNumber(
                                                  getFieldValue([
                                                    "partyLedger",
                                                    index1,
                                                    "depInvDetail",
                                                  ]).reduce(
                                                    (
                                                      acc: number,
                                                      curr: any
                                                    ) => {
                                                      return (acc +=
                                                        Utils.getNumber(
                                                          curr?.value
                                                        ));
                                                    },
                                                    0
                                                  )
                                                )
                                              ) {
                                                return Promise.reject(
                                                  new Error(
                                                    "Reference amount do not match!"
                                                  )
                                                );
                                              } else {
                                                return Promise.resolve();
                                              }
                                            } else {
                                              return Promise.resolve();
                                            }
                                          },
                                        }),
                                      ]}
                                    >
                                      <InputNumber
                                        disabled={
                                          isOpeningOrClosingVoucher ||
                                          fields.length === index1 + 1
                                        }
                                        defaultValue="0.00"
                                        // disabled={isInputDisabled}
                                        // prefix="&#8377;"
                                        ref={(el) =>
                                          (creditRefs.current[index1] = el)
                                        }
                                        bordered={false}
                                        variant="filled"
                                        step={0.01}
                                        precision={2}
                                        style={{
                                          width: "100%",
                                          backgroundColor:
                                            fields.length === index1 + 1
                                              ? `${themeData.themeData?.themeColor}40`
                                              : "#FFFFFF",
                                        }}
                                        controls={false}
                                        onBlur={(e) => {
                                          // handleAllLedgerValue();
                                          onCreditBlur(e.target.value, index1);
                                          // handelAmountChange(
                                          //   Utils.getNumber(e.target.value),
                                          //   index
                                          // );
                                          // getAllocatedAmount(Utils.getNumber(e.target.value));
                                          Number(e.target.value) > 0 &&
                                            onChangeRefAmountSet(
                                              e.target.value,
                                              index1,
                                              true
                                            );
                                        }}
                                        onChange={(e: any) => {
                                          onChangeRefAmountSet(e, index1, true);
                                        }}
                                        onFocus={(e) => {
                                          handleInputFocus(e, form);
                                        }}
                                        onKeyPress={handleDecimalValues}
                                      />
                                    </Form.Item>
                                  </td>

                                  <td
                                    style={{
                                      width: 24,
                                      verticalAlign: "center",
                                      textAlign: "center",
                                    }}
                                  >
                                    {fields.length !== index1 + 1 && (
                                      <img
                                        className="cursor mx-1"
                                        onClick={() => {
                                          setDeleteItemList({
                                            name: name,
                                            index: index1,
                                          });
                                          setConfirmation(true);
                                        }}
                                        src={deleteImg}
                                        alt="Delete"
                                      />
                                    )}
                                  </td>
                                </tr>

                                {/* Nest Form.List */}
                                <tr
                                  style={{
                                    display: !isInputDisabled
                                      ? "none"
                                      : "contents",
                                  }}
                                >
                                  <td></td>
                                  <td>
                                    <table style={{ width: "100%" }}>
                                      <tbody>
                                        {disabledAmountInputs[index1] ===
                                        Party_Tax.party ? (
                                          <Form.Item className="m-0" name="ref">
                                            <Form.List name={[name, "ref"]}>
                                              {(
                                                subFields,
                                                { add, remove, move }
                                              ) => {
                                                return (
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                    }}
                                                  >
                                                    {subFields.map(
                                                      (subField, index) => {
                                                        const isInputDisabled1 =
                                                          subFields.length !==
                                                          index + 1
                                                            ? true
                                                            : false;
                                                        return (
                                                          <tr
                                                            // style={{
                                                            //   paddingLeft:
                                                            //     "105px",
                                                            // }}
                                                            key={subField.key}
                                                          >
                                                            <td>
                                                              {index === 0 ? (
                                                                <Tooltip
                                                                  title="New Reference"
                                                                  placement="left"
                                                                  color="#389e0d"
                                                                >
                                                                  <Avatar
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      verticalAlign:
                                                                        "middle",
                                                                      color:
                                                                        "#389e0d",
                                                                      backgroundColor:
                                                                        "#f6ffed",
                                                                      borderColor:
                                                                        "#b7eb8f",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                    size="small"
                                                                  >
                                                                    N
                                                                  </Avatar>
                                                                </Tooltip>
                                                              ) : (
                                                                <Tooltip
                                                                  title="Old Reference"
                                                                  placement="left"
                                                                  color="#08979C"
                                                                >
                                                                  <Avatar
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                      verticalAlign:
                                                                        "middle",
                                                                      color:
                                                                        "#08979C",
                                                                      backgroundColor:
                                                                        "#E6FFFB",
                                                                      borderColor:
                                                                        "rgb(127 231 235)",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                    size="small"
                                                                  >
                                                                    A
                                                                  </Avatar>
                                                                </Tooltip>
                                                              )}
                                                            </td>
                                                            <td
                                                              style={{
                                                                width: "30%",
                                                              }}
                                                            >
                                                              <Form.Item
                                                                className="m-0"
                                                                name={[
                                                                  subField.name,
                                                                  "name",
                                                                ]}
                                                                rules={[
                                                                  {
                                                                    required:
                                                                      index !==
                                                                        0 &&
                                                                      subFields.length !==
                                                                        index +
                                                                          1 &&
                                                                      form.getFieldValue(
                                                                        [
                                                                          "partyLedger",
                                                                          index1,
                                                                          "ref",
                                                                          index,
                                                                          "value",
                                                                        ]
                                                                      ) > 0
                                                                        ? true
                                                                        : false,
                                                                    message:
                                                                      "Select an invoice",
                                                                  },
                                                                ]}
                                                              >
                                                                <Select
                                                                  disabled={
                                                                    index ===
                                                                      0 && true
                                                                  }
                                                                  // bordered={index === 0 ? true : false}
                                                                  bordered={
                                                                    false
                                                                  }
                                                                  // variant="filled"
                                                                  style={{
                                                                    backgroundColor:
                                                                      // index === 0
                                                                      //   ? `${themeData.themeData?.themeColor}40`
                                                                      //   :
                                                                      "#FFFFFF",
                                                                  }}
                                                                  // variant="filled"
                                                                  // className="variantFilledSelect"
                                                                  labelInValue
                                                                  showSearch
                                                                  optionFilterProp="children"
                                                                  placeholder="Select account"
                                                                  filterOption={(
                                                                    input,
                                                                    option
                                                                  ) =>
                                                                    (
                                                                      option?.label?.toString() ??
                                                                      ""
                                                                    )
                                                                      .toLowerCase()
                                                                      .includes(
                                                                        input.toLowerCase()
                                                                      )
                                                                  }
                                                                  // showArrow={false}
                                                                  notFoundContent={
                                                                    null
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    if (
                                                                      subFields.length ===
                                                                      index + 1
                                                                    )
                                                                      add();

                                                                    onChangeSetPartyRef(
                                                                      index1,
                                                                      index,
                                                                      e?.value
                                                                    );
                                                                  }}
                                                                  options={partyRef[
                                                                    index1
                                                                  ]
                                                                    ?.filter(
                                                                      (
                                                                        option: any
                                                                      ) =>
                                                                        !selectPartyRef[
                                                                          index1
                                                                        ]?.includes(
                                                                          option.parentRef
                                                                        )
                                                                    )
                                                                    .map(
                                                                      (
                                                                        value: any
                                                                      ) => ({
                                                                        value:
                                                                          value?.parentRef,
                                                                        label:
                                                                          value?.name,
                                                                        // title: value?.balance,
                                                                      })
                                                                    )}
                                                                />
                                                              </Form.Item>
                                                            </td>
                                                            <td
                                                              style={{
                                                                width: "20%",
                                                              }}
                                                            >
                                                              <Form.Item
                                                                className="m-0"
                                                                name={[
                                                                  subField.name,
                                                                  "dueAmount",
                                                                ]}
                                                              >
                                                                <InputNumber
                                                                  bordered={
                                                                    false
                                                                  }
                                                                  // variant="filled"
                                                                  step={0.01}
                                                                  disabled
                                                                  controls={
                                                                    false
                                                                  }
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                    backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                                  }}
                                                                  placeholder="Amount"
                                                                />
                                                              </Form.Item>
                                                            </td>

                                                            <td
                                                              style={{
                                                                width: "40%",
                                                              }}
                                                            >
                                                              <Form.Item
                                                                className="m-0"
                                                                name={[
                                                                  subField.name,
                                                                  "value",
                                                                ]}
                                                                rules={[
                                                                  // {
                                                                  //   required:
                                                                  //     index !==
                                                                  //       0 &&
                                                                  //     form.getFieldValue(
                                                                  //       [
                                                                  //         "partyLedger",
                                                                  //         index1,
                                                                  //         "ref",
                                                                  //         index,
                                                                  //         "name",
                                                                  //       ]
                                                                  //     )
                                                                  //       ? true
                                                                  //       : false,
                                                                  //   message:
                                                                  //     "Enter amount",
                                                                  // },
                                                                  // {
                                                                  //   validator: (
                                                                  //     _,
                                                                  //     value
                                                                  //   ) => {
                                                                  //     if (
                                                                  //       value <
                                                                  //       0
                                                                  //     ) {
                                                                  //       return Promise.reject(
                                                                  //         "Number must be non-negative"
                                                                  //       );
                                                                  //     }
                                                                  //     return Promise.resolve();
                                                                  //   },
                                                                  // },
                                                                  {
                                                                    validator: (
                                                                      _,
                                                                      value
                                                                    ) => {
                                                                      const isRequired =
                                                                        index !==
                                                                          0 &&
                                                                        form.getFieldValue(
                                                                          [
                                                                            "partyLedger",
                                                                            index1,
                                                                            "ref",
                                                                            index,
                                                                            "name",
                                                                          ]
                                                                        );

                                                                      if (
                                                                        isRequired &&
                                                                        (!value ||
                                                                          Number(
                                                                            value
                                                                          ) ===
                                                                            0)
                                                                      ) {
                                                                        return Promise.reject(
                                                                          new Error(
                                                                            "Enter amount"
                                                                          )
                                                                        );
                                                                      }

                                                                      if (
                                                                        value <
                                                                        0
                                                                      ) {
                                                                        return Promise.reject(
                                                                          new Error(
                                                                            "Number must be non-negative"
                                                                          )
                                                                        );
                                                                      }

                                                                      return Promise.resolve();
                                                                    },
                                                                  },
                                                                ]}
                                                              >
                                                                <InputNumber
                                                                  min={0}
                                                                  step={0.01}
                                                                  precision={2}
                                                                  disabled={
                                                                    isOpeningOrClosingVoucher ||
                                                                    subFields.length ===
                                                                      index + 1
                                                                  }
                                                                  max={
                                                                    index !== 0
                                                                      ? journalId
                                                                        ? Math.round(
                                                                            (form.getFieldValue(
                                                                              [
                                                                                "partyLedger",
                                                                                index1,
                                                                                "ref",
                                                                                index,
                                                                                "dueAmount",
                                                                              ]
                                                                            ) +
                                                                              form.getFieldValue(
                                                                                [
                                                                                  "partyLedger",
                                                                                  index1,
                                                                                  "ref",
                                                                                  index,
                                                                                  "maxAmount",
                                                                                ]
                                                                              )) *
                                                                              100
                                                                          ) /
                                                                          100
                                                                        : Math.round(
                                                                            form.getFieldValue(
                                                                              [
                                                                                "partyLedger",
                                                                                index1,
                                                                                "ref",
                                                                                index,
                                                                                "dueAmount",
                                                                              ]
                                                                            ) *
                                                                              100
                                                                          ) /
                                                                          100
                                                                      : Infinity
                                                                  }
                                                                  controls={
                                                                    false
                                                                  }
                                                                  bordered={
                                                                    false
                                                                  }
                                                                  variant="filled"
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                    backgroundColor:
                                                                      subFields.length ===
                                                                      index + 1
                                                                        ? `${themeData.themeData?.themeColor}40`
                                                                        : "#FFFFFF",
                                                                  }}
                                                                  placeholder="Amount"
                                                                  onBlur={() => {
                                                                    // if (
                                                                    //   subFields.length ===
                                                                    //     index +
                                                                    //       1 &&
                                                                    //   form.getFieldValue(
                                                                    //     [
                                                                    //       "partyLedger",
                                                                    //       index1,
                                                                    //       "ref",
                                                                    //       index,
                                                                    //       "value",
                                                                    //     ]
                                                                    //   ) > 0
                                                                    // )
                                                                    //   add();
                                                                  }}
                                                                  onChange={(
                                                                    e: any
                                                                  ) => {
                                                                    onChangeRefAmountSet(
                                                                      e,
                                                                      index1,
                                                                      false
                                                                    );

                                                                    if (
                                                                      Utils.getNumber(
                                                                        form.getFieldValue(
                                                                          [
                                                                            "partyLedger",
                                                                            index1,
                                                                            "amount",
                                                                          ]
                                                                        )
                                                                      ) !==
                                                                      Utils.getNumber(
                                                                        form
                                                                          .getFieldValue(
                                                                            [
                                                                              "partyLedger",
                                                                              index1,
                                                                              "ref",
                                                                            ]
                                                                          )
                                                                          .reduce(
                                                                            (
                                                                              acc: number,
                                                                              curr: any
                                                                            ) => {
                                                                              return (acc +=
                                                                                Utils.getNumber(
                                                                                  curr?.value
                                                                                ));
                                                                            },
                                                                            0
                                                                          )
                                                                      )
                                                                    ) {
                                                                      console.log(
                                                                        "error"
                                                                      );
                                                                      form.validateFields(
                                                                        [
                                                                          "partyLedger",
                                                                          index1,
                                                                          "amount",
                                                                        ]
                                                                      );
                                                                      return Promise.resolve();
                                                                    }
                                                                  }}
                                                                  onFocus={(
                                                                    e
                                                                  ) => {
                                                                    handleInputFocus(
                                                                      e,
                                                                      form
                                                                    );
                                                                  }}
                                                                  onKeyPress={
                                                                    handleDecimalValues
                                                                  }
                                                                />
                                                              </Form.Item>
                                                            </td>
                                                            <td
                                                            // style={{ width: "20%" }}
                                                            >
                                                              <td
                                                                style={{
                                                                  width: 25,
                                                                  border:
                                                                    "none",
                                                                }}
                                                              >
                                                                {index !== 0 &&
                                                                  subFields.length !==
                                                                    index +
                                                                      1 && (
                                                                    <CloseOutlined
                                                                      style={{
                                                                        color:
                                                                          "red",
                                                                        paddingLeft:
                                                                          "6px",
                                                                      }}
                                                                      onClick={() => {
                                                                        form.setFields(
                                                                          [
                                                                            {
                                                                              name: [
                                                                                "partyLedger",
                                                                                index1,
                                                                                "ref",
                                                                                index,
                                                                                "value",
                                                                              ],
                                                                              errors:
                                                                                [],
                                                                            },
                                                                          ]
                                                                        );
                                                                        remove(
                                                                          subField.name
                                                                        );
                                                                        onChangeRefAmountSet(
                                                                          "0",
                                                                          index1,
                                                                          false,
                                                                          index
                                                                        );
                                                                      }}
                                                                    />
                                                                  )}
                                                              </td>
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                );
                                              }}
                                            </Form.List>
                                          </Form.Item>
                                        ) : (
                                          <Form.Item
                                            className="m-0"
                                            name="depInvDetail"
                                          >
                                            <Form.List
                                              name={[name, "depInvDetail"]}
                                            >
                                              {(
                                                subFields,
                                                { add, remove, move }
                                              ) => {
                                                return (
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      flexDirection: "column",
                                                    }}
                                                  >
                                                    {subFields.map(
                                                      (subField, index) => {
                                                        // const isInputDisabled1 =
                                                        //   subFields.length !==
                                                        //   index + 1
                                                        //     ? true
                                                        //     : false;
                                                        return (
                                                          <tr
                                                            // style={{
                                                            //   paddingLeft:
                                                            //     "105px",
                                                            // }}
                                                            key={subField.key}
                                                          >
                                                            <td
                                                              style={{
                                                                width:
                                                                  "33.33px",
                                                              }}
                                                              className="textCenter"
                                                            >
                                                              {index + 1}.
                                                            </td>
                                                            <td
                                                              style={{
                                                                width: "30%",
                                                              }}
                                                            >
                                                              <Form.Item
                                                                className="m-0"
                                                                name={[
                                                                  subField.name,
                                                                  "name",
                                                                ]}
                                                                rules={[
                                                                  {
                                                                    required:
                                                                      index !==
                                                                        0 &&
                                                                      subFields.length !==
                                                                        index +
                                                                          1 &&
                                                                      form.getFieldValue(
                                                                        [
                                                                          "partyLedger",
                                                                          index1,
                                                                          "depInvDetail",
                                                                          index,
                                                                          "value",
                                                                        ]
                                                                      ) > 0
                                                                        ? true
                                                                        : false,
                                                                    message:
                                                                      "Select an asset",
                                                                  },
                                                                ]}
                                                              >
                                                                <Select
                                                                  // bordered={index === 0 ? true : false}
                                                                  bordered={
                                                                    false
                                                                  }
                                                                  // variant="filled"
                                                                  style={{
                                                                    backgroundColor:
                                                                      // index === 0
                                                                      //   ? `${themeData.themeData?.themeColor}40`
                                                                      //   :
                                                                      "#FFFFFF",
                                                                  }}
                                                                  // variant="filled"
                                                                  // className="variantFilledSelect"
                                                                  labelInValue
                                                                  showSearch
                                                                  optionFilterProp="children"
                                                                  placeholder="Select asset"
                                                                  filterOption={(
                                                                    input,
                                                                    option
                                                                  ) =>
                                                                    (
                                                                      option?.label?.toString() ??
                                                                      ""
                                                                    )
                                                                      .toLowerCase()
                                                                      .includes(
                                                                        input.toLowerCase()
                                                                      )
                                                                  }
                                                                  // showArrow={false}
                                                                  notFoundContent={
                                                                    null
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    if (
                                                                      subFields.length ===
                                                                      index + 1
                                                                    )
                                                                      add();

                                                                    onChangeSetAssetRef(
                                                                      index1,
                                                                      index,
                                                                      e?.value
                                                                    );

                                                                    // onChangeSetPartyRef(
                                                                    //   index1,
                                                                    //   index,
                                                                    //   e?.value
                                                                    // );
                                                                  }}
                                                                  options={assetRef[
                                                                    index1
                                                                  ]
                                                                    ?.filter(
                                                                      (
                                                                        option: any
                                                                      ) =>
                                                                        !selectAssetRef[
                                                                          index1
                                                                        ]?.includes(
                                                                          option.id
                                                                        )
                                                                    )
                                                                    .map(
                                                                      (
                                                                        value: any
                                                                      ) => ({
                                                                        value:
                                                                          value.id,
                                                                        label:
                                                                          value
                                                                            ?.voucherRef
                                                                            ?.name,
                                                                        price:
                                                                          value?.price,
                                                                        qty: value?.qty,
                                                                        date: value?.date,
                                                                        voucherRefId:
                                                                          value
                                                                            ?.voucherRef
                                                                            ?.id,
                                                                        voucherRefName:
                                                                          value
                                                                            ?.voucherRef
                                                                            ?.name,

                                                                        // title: value?.balance,
                                                                      })
                                                                    )}
                                                                  optionRender={(
                                                                    itm
                                                                  ) => (
                                                                    <div>
                                                                      <Row
                                                                        justify={
                                                                          "space-between"
                                                                        }
                                                                      >
                                                                        <Col>
                                                                          <p
                                                                            style={{
                                                                              fontWeight:
                                                                                "bold",
                                                                              color:
                                                                                "dimgray",
                                                                            }}
                                                                          >
                                                                            {
                                                                              itm?.label
                                                                            }
                                                                          </p>
                                                                        </Col>
                                                                      </Row>
                                                                      <div>
                                                                        {/* {itm
                                                                          .data
                                                                          ?.voucherRefName && (
                                                                          <span>
                                                                            <span
                                                                              style={{
                                                                                fontWeight:
                                                                                  "500",
                                                                                color:
                                                                                  "dimgray",
                                                                              }}
                                                                            >
                                                                              Bill
                                                                              No.
                                                                              -
                                                                            </span>
                                                                            {
                                                                              itm
                                                                                .data
                                                                                ?.voucherRefName
                                                                            }
                                                                          </span>
                                                                        )} */}
                                                                        {itm
                                                                          .data
                                                                          ?.date && (
                                                                          <span>
                                                                            <span
                                                                              style={{
                                                                                fontWeight:
                                                                                  "500",
                                                                                color:
                                                                                  "dimgray",
                                                                              }}
                                                                            >
                                                                              {" "}
                                                                              Date.
                                                                              -
                                                                            </span>
                                                                            {Utils.getFormattedDate(
                                                                              itm
                                                                                .data
                                                                                ?.date
                                                                            )}
                                                                          </span>
                                                                        )}
                                                                      </div>
                                                                    </div>
                                                                    //   ),
                                                                    // </Space>
                                                                  )}
                                                                />
                                                              </Form.Item>
                                                            </td>
                                                            <td
                                                              style={{
                                                                width: "20%",
                                                              }}
                                                            >
                                                              <Form.Item
                                                                className="m-0"
                                                                name={[
                                                                  subField.name,
                                                                  "qty",
                                                                ]}
                                                              >
                                                                <InputNumber
                                                                  bordered={
                                                                    false
                                                                  }
                                                                  // variant="filled"
                                                                  step={0.01}
                                                                  disabled
                                                                  controls={
                                                                    false
                                                                  }
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                    backgroundColor: `${themeData.themeData?.themeColor}40`,
                                                                  }}
                                                                  placeholder="Available Qty"
                                                                />
                                                              </Form.Item>
                                                            </td>

                                                            <td
                                                              style={{
                                                                width: "40%",
                                                              }}
                                                            >
                                                              <Form.Item
                                                                className="m-0"
                                                                name={[
                                                                  subField.name,
                                                                  "value",
                                                                ]}
                                                                rules={[
                                                                  {
                                                                    required:
                                                                      form.getFieldValue(
                                                                        [
                                                                          "partyLedger",
                                                                          index1,
                                                                          "depInvDetail",
                                                                          index,
                                                                          "name",
                                                                        ]
                                                                      )
                                                                        ? true
                                                                        : false,
                                                                    message:
                                                                      "Enter amount",
                                                                  },
                                                                  {
                                                                    validator: (
                                                                      _,
                                                                      value
                                                                    ) => {
                                                                      if (
                                                                        value <
                                                                        0
                                                                      ) {
                                                                        return Promise.reject(
                                                                          "Number must be non-negative"
                                                                        );
                                                                      }
                                                                      return Promise.resolve();
                                                                    },
                                                                  },
                                                                ]}
                                                              >
                                                                <InputNumber
                                                                  min={0}
                                                                  step={0.01}
                                                                  precision={2}
                                                                  disabled={
                                                                    isOpeningOrClosingVoucher ||
                                                                    subFields.length ===
                                                                      index + 1
                                                                  }
                                                                  // max={
                                                                  //   index !== 0
                                                                  //     ? journalId
                                                                  //       ? Math.round(
                                                                  //           (form.getFieldValue(
                                                                  //             [
                                                                  //               "partyLedger",
                                                                  //               index1,
                                                                  //               "ref",
                                                                  //               index,
                                                                  //               "dueAmount",
                                                                  //             ]
                                                                  //           ) +
                                                                  //             form.getFieldValue(
                                                                  //               [
                                                                  //                 "partyLedger",
                                                                  //                 index1,
                                                                  //                 "ref",
                                                                  //                 index,
                                                                  //                 "maxAmount",
                                                                  //               ]
                                                                  //             )) *
                                                                  //             100
                                                                  //         ) /
                                                                  //         100
                                                                  //       : Math.round(
                                                                  //           form.getFieldValue(
                                                                  //             [
                                                                  //               "partyLedger",
                                                                  //               index1,
                                                                  //               "ref",
                                                                  //               index,
                                                                  //               "dueAmount",
                                                                  //             ]
                                                                  //           ) *
                                                                  //             100
                                                                  //         ) /
                                                                  //         100
                                                                  //     : Infinity
                                                                  // }
                                                                  controls={
                                                                    false
                                                                  }
                                                                  bordered={
                                                                    false
                                                                  }
                                                                  variant="filled"
                                                                  style={{
                                                                    width:
                                                                      "100%",
                                                                    backgroundColor:
                                                                      subFields.length ===
                                                                      index + 1
                                                                        ? `${themeData.themeData?.themeColor}40`
                                                                        : "#FFFFFF",
                                                                  }}
                                                                  placeholder="Amount"
                                                                  onBlur={() => {
                                                                    checkAssetRefValidation(
                                                                      index1
                                                                    );
                                                                  }}
                                                                  // onChange={(
                                                                  //   e: any
                                                                  // ) => {

                                                                  // }}
                                                                  onFocus={(
                                                                    e
                                                                  ) => {
                                                                    handleInputFocus(
                                                                      e,
                                                                      form
                                                                    );
                                                                  }}
                                                                  onKeyPress={
                                                                    handleDecimalValues
                                                                  }
                                                                />
                                                              </Form.Item>
                                                            </td>
                                                            <td
                                                            // style={{ width: "20%" }}
                                                            >
                                                              <td
                                                                style={{
                                                                  width: 25,
                                                                  border:
                                                                    "none",
                                                                }}
                                                              >
                                                                {/* index !== 0 && */}
                                                                {subFields.length !==
                                                                  index + 1 && (
                                                                  <CloseOutlined
                                                                    style={{
                                                                      color:
                                                                        "red",
                                                                      paddingLeft:
                                                                        "6px",
                                                                    }}
                                                                    onClick={() => {
                                                                      remove(
                                                                        subField.name
                                                                      );

                                                                      onChageAssetRef(
                                                                        "0",
                                                                        index1,
                                                                        false,
                                                                        index
                                                                      );

                                                                      // onChangeRefAmountSet(
                                                                      //   "0",
                                                                      //   index1,
                                                                      //   false,
                                                                      //   index
                                                                      // );
                                                                    }}
                                                                  />
                                                                )}
                                                              </td>
                                                            </td>
                                                          </tr>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                );
                                              }}
                                            </Form.List>
                                          </Form.Item>
                                        )}
                                      </tbody>
                                    </table>
                                  </td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                </tr>
                              </>
                            );
                          })}
                        </>
                      );
                    }}
                  </Form.List>
                </tbody>
                {/* {itemLength > 0 && (
                <tfoot>
                  <tr>
                    <th colSpan={5} className="textEnd pe-14">
                      Total
                    </th>
                    <th colSpan={2} className="textEnd pe-14">
                      {footerTotal.qty}
                    </th>
                    <th colSpan={2} className="textEnd pe-12">
                      ₹ {Utils.getFormattedNumber(footerTotal.unitPrice)}
                    </th>
                    <th colSpan={2} className="textEnd pe-12">
                      ₹ {Utils.getFormattedNumber(footerTotal.discount)}
                    </th>
                    {isGSTEnabled && (
                      <th colSpan={2} className="textEnd pe-12">
                        ₹ {Utils.getFormattedNumber(footerTotal.gst)}
                      </th>
                    )}
                    <th className="textEnd pe-12">
                      ₹ {Utils.getFormattedNumber(footerTotal.amount)}
                    </th>
                  </tr>
                </tfoot>
              )} */}
              </table>
            </div>

            <Row className="pt-10">
              <Col xl={6} lg={8} md={24} xs={24} className="pt-10">
                <Form.Item name="narration" className="m-0">
                  <TextArea
                    placeholder="Write narration"
                    autoSize={{ minRows: 2, maxRows: 4 }}
                  />
                </Form.Item>

                <Form.Item
                  name="attachments"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    return e.fileList;
                  }}
                  // className="m-0"
                  style={{ paddingTop: "10px", margin: "0px" }}
                >
                  <Upload
                    multiple
                    maxCount={2}
                    // accept={".png, .jpg, .jpeg, .pdf"}
                    // accept={".png, .jpg, .jpeg"}
                    beforeUpload={() => {
                      return false;
                    }}
                    onRemove={(e: any) => {
                      if ((draftId || journalId) && e?.id) {
                        setDeleteUploadId([...deleteUploadId, e?.id]);
                      }
                    }}
                    onPreview={(e: any) => {
                      console.log("preview", e);
                      if ((draftId || journalId) && e?.path) {
                        setPreviewImage({
                          isBaseConvert: false,
                          path: e,
                        });
                      } else if (e.type?.split("/")[0] === "image") {
                        setPreviewImage({
                          isBaseConvert: true,
                          path: e,
                        });
                      }
                    }}
                  >
                    <Button
                      icon={<UploadOutlined />}
                      style={{ backgroundColor: "ButtonFace" }}
                    >
                      Upload
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col xl={10} xs={0}></Col>

              <Col xl={8} lg={24} md={24} xs={24}>
                <Row>
                  <Col lg={8} md={8} xs={8}>
                    <span>Total Amount</span>
                  </Col>
                  <Col lg={8} md={8} xs={8} className="textEnd">
                    <span
                      style={{
                        color: "rgb(11, 48, 142)",
                        fontWeight: "400",
                        fontSize: "18px",
                      }}
                    >
                      ₹ {Utils.getFormattedNumber(debitSubTotal)}
                    </span>
                  </Col>
                  <Col lg={8} md={8} xs={8} className="textEnd">
                    <span
                      style={{
                        color: "rgb(11, 48, 142)",
                        fontWeight: "400",
                        fontSize: "18px",
                      }}
                    >
                      ₹ {Utils.getFormattedNumber(creditSubTotal)}
                    </span>
                  </Col>
                </Row>

                <Divider
                  style={{
                    borderBottom: "2px solid rgb(203, 203, 203)",
                  }}
                  className="my-5"
                />

                <Row justify="end" className="mt-10">
                  <Col>
                    <Tooltip
                      title={<p>ALT+C</p>}
                      placement="bottomLeft"
                      open={showKeys}
                    >
                      <Button
                        onClick={() => {
                          // navigate(
                          //   `/accounts/clients/${currentClient?.id}/journals`
                          // )
                          if (
                            (debitSubTotal > 0 || creditSubTotal > 0) &&
                            !journalId
                          ) {
                            save(false, true);
                          }
                          navigate(-1);
                        }}
                      >
                        Cancel
                      </Button>
                    </Tooltip>
                  </Col>
                  <Col className="ps-14">
                    <Form.Item>
                      <Tooltip
                        title={<p>ALT+S</p>}
                        placement="bottomLeft"
                        open={showKeys}
                      >
                        <Button
                          type="primary"
                          onClick={() => save()}
                          loading={saveButtonLoading}
                          disabled={
                            isVoucherLocked
                              ? true
                              : isOpeningOrClosingVoucher
                              ? true
                              : debitSubTotal === creditSubTotal &&
                                debitSubTotal !== 0 &&
                                debitSubTotal !== 0
                              ? false
                              : true
                          }
                        >
                          {journalId ? "Update" : "Save"}
                        </Button>
                      </Tooltip>
                    </Form.Item>
                  </Col>

                  {/* <Col className="ps-14">
                  <Form.Item>
                    <Button
                      // loading={saveNewLoading}
                      // onClick={() => {
                      //   addDeliveryChallan(true);
                      // }}
                      type="primary"
                    >
                      {journalId ? "Update & New" : "Save & New"}
                    </Button>
                  </Form.Item>
                </Col> */}
                </Row>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>

      {openModel.type === "addLedger" && (
        <AddLedger
          openDrawer={openModel?.param.open}
          id={""}
          setOpenDrawer={() => setOpenModel({ type: "", param: "" })}
          setTrigger={() => setTrigger(!trigger)}
          setAddLedgerResponse={setAddLedgerResponse}
        />
      )}
      {previewImage.path && (
        <DocumentPreview
          open={true}
          onCancel={() =>
            setPreviewImage({
              path: "",
              isBaseConvert: false,
              // uploadType: "",
            })
          }
          documentDetails={previewImage}
        />
      )}
    </>
  );
};

export default AddJournal;
